var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "difference"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1859_22658",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1859_22658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "difference_2",
    d: "M12.75 10.75H14.25V8.74995H16.25V7.25H14.25V5.25H12.75V7.25H10.75V8.74995H12.75V10.75ZM10.75 14.75H16.25V13.25H10.75V14.75ZM8.3077 18.5C7.80257 18.5 7.375 18.325 7.025 17.975C6.675 17.625 6.5 17.1974 6.5 16.6923V3.3077C6.5 2.80257 6.675 2.375 7.025 2.025C7.375 1.675 7.80257 1.5 8.3077 1.5H15.25L20.5 6.74995V16.6923C20.5 17.1974 20.325 17.625 19.975 17.975C19.625 18.325 19.1974 18.5 18.6923 18.5H8.3077ZM8.3077 17H18.6923C18.7692 17 18.8397 16.9679 18.9038 16.9038C18.9679 16.8397 19 16.7692 19 16.6923V7.49995L14.5 2.99998H8.3077C8.23077 2.99998 8.16024 3.03203 8.09613 3.09613C8.03203 3.16024 7.99998 3.23077 7.99998 3.3077V16.6923C7.99998 16.7692 8.03203 16.8397 8.09613 16.9038C8.16024 16.9679 8.23077 17 8.3077 17ZM4.3077 22.5C3.80257 22.5 3.375 22.325 3.025 21.975C2.675 21.625 2.5 21.1974 2.5 20.6923V7.5H3.99998V20.6923C3.99998 20.7692 4.03202 20.8397 4.09613 20.9038C4.16024 20.9679 4.23077 21 4.3077 21H14.5V22.4999L4.3077 22.5Z",
    fill: "#B6B6B6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractImport);
export default __webpack_public_path__ + "static/media/contract_import.d30e7eb904e28f44639e54766adc5b48.svg";
export { ForwardRef as ReactComponent };